import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WarningModalComponent {

  warningTitle = '';
  warningContent = '';

  /**
   * Initialize variables with the modal config
   * @param data
   */
  constructor(public dialogRef: MdDialogRef<WarningModalComponent>, @Inject(MD_DIALOG_DATA) public data: any) {
    this.warningTitle = data.title;
    this.warningContent = data.content;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/warning-modal/warning-modal.component.ts